/**
 * Module dependencies.
 */

import { Image as ImageComponent } from 'components/atoms/image/image';
import { MdClose, MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import styled from '@emotion/styled';

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div`
  padding-top: 40px;
  width: 100%;
`;

/**
 * Export `Gallery` styled component.
 */

export const Gallery = styled.div`
  column-count: 4;
  column-gap: 0px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    column-count: 3;
  }

  @media (max-width: 576px) {
    column-count: 2;
  }
`;

/**
 * Export `Image` styled component.
 */

export const Image = styled(ImageComponent)`
  display: block;
  box-shadow: 0 0px 2px rgba(0, 0, 0, 0);
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border: 10px solid transparent;

  &:hover {
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0);
    transform: scale(1.08);
    z-index: 100;
  }
`;

/**
 * Export `ButtonContent` styled component.
 */

export const ButtonContent = styled.div`
  width: 100px;
  height: 100px;
`;

/**
 * Export `StyledMdNavigateBefore` styled component.
 */

export const StyledMdNavigateBefore = styled(MdNavigateBefore)`
  font-size: 150px;
  margin-top: -50px;
  opacity: 0.7;

  @media (max-width: 768px) {
    font-size: 100px;
    margin-top: -26px;
  }

  @media (max-width: 576px) {
    font-size: 70px;
    margin-right: -10px;
    margin-top: -35px;
  }
`;

/**
 * Export `StyledMdNavigateNext` styled component.
 */

export const StyledMdNavigateNext = styled(MdNavigateNext)`
  font-size: 150px;
  margin-top: 50px;
  opacity: 0.7;

  @media (max-width: 768px) {
    font-size: 100px;
  }

  @media (max-width: 576px) {
    font-size: 70px;
    margin-top: 0px;
  }
`;

/**
 * Export `StyledMdClose` styled component.
 */

export const StyledMdClose = styled(MdClose)`
  font-size: 70px;
  margin-top: 30px;
  margin-right: 30px;
  opacity: 0.7;

  @media (max-width: 768px) {
    font-size: 50px;
    margin-top: 20px;
    margin-right: 20px;
  }

  @media (max-width: 576px) {
    font-size: 30px;
    margin-top: 8px;
    margin-right: 8px;
  }
`;
